import axios from "axios";
import {
  API_BASE_URL,
  API_PREFIX,
  DEFAULT_HEADERS,
  CORS_CONFIG,
  REQUEST_TIMEOUT,
} from "./constants";
import {
  clearStoredSession,
  redirectAfterSessionExpired,
} from "../utils/session";

/**
 * Cliente HTTP configurado con base URL, headers por defecto, CORS y timeout.
 * Incluye interceptor para adjuntar el token de autenticación cuando exista.
 */
const client = axios.create({
  baseURL: `${API_BASE_URL}${API_PREFIX ? `/${API_PREFIX}` : ""}`,
  headers: { ...DEFAULT_HEADERS },
  timeout: REQUEST_TIMEOUT,
  ...CORS_CONFIG,
});

// Interceptor de request: añadir token y tratar FormData
client.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    const skipAuth = config.skipAuth === true;
    if (!skipAuth && token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // Con FormData no debe ir Content-Type: application/json; axios/navegador ponen multipart/form-data + boundary
    if (config.data instanceof FormData) {
      delete config.headers["Content-Type"];
    }
    return config;
  },
  (error) => Promise.reject(error)
);

const isPublicAuthRequest = (config) => {
  const url = String(config?.url || "");
  return /(^|\/)login(\?|$)|recoverPassword|register/i.test(url);
};

// Interceptor de response: centralizar manejo de errores (401, etc.)
client.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const hadStoredSession = Boolean(localStorage.getItem("token"));

    if (status === 401 && hadStoredSession && !isPublicAuthRequest(error.config)) {
      clearStoredSession();
      redirectAfterSessionExpired();
    }

    return Promise.reject(error);
  }
);

export default client;
